import {Component} from '@angular/core';
import {LanguageService} from '../../../services/language.service';

/**
 * @deprecated The class should not be used
 */
@Component({
  selector: 'app-options-section',
  styleUrls: ['./options-section.component.scss'],
  templateUrl: './options-section.component.html',
})
export class OptionsSectionComponent {

  constructor(public languageService: LanguageService) {}
}
